import { AppStructureBuilderError } from './error';
export function addPlugin({ viewName, scopeName, pluginName, pluginParams, }) {
    this.updateAppStructure(draftBuilder => {
        const view = draftBuilder.getView(viewName);
        const scope = scopeName ? view?.scopes[scopeName] : undefined;
        if (!view) {
            throw new AppStructureBuilderError(`View ${viewName} not found`);
        }
        if (scopeName && !scope) {
            throw new AppStructureBuilderError(`Scope ${scopeName} not found in view ${viewName}`);
        }
        const plugin = { name: pluginName, arguments: pluginParams };
        if (scope) {
            scope.plugins = scope.plugins || {};
            scope.plugins[pluginName] = plugin;
        }
        else {
            view.plugins = view.plugins || {};
            view.plugins[pluginName] = plugin;
        }
    });
    return this;
}
export function removePlugin({ name, viewName, scopeName }) {
    this.updateAppStructure(draftBuilder => {
        const view = draftBuilder.getView(viewName);
        const scope = scopeName ? view?.scopes[scopeName] : undefined;
        if (!view) {
            throw new AppStructureBuilderError(`View ${viewName} not found`);
        }
        if (scopeName && !scope) {
            throw new AppStructureBuilderError(`Scope ${scopeName} not found in view ${viewName}`);
        }
        if (scope) {
            if (!scope.plugins) {
                throw new AppStructureBuilderError(`Scope ${scopeName} has no plugins`);
            }
            delete scope.plugins[name];
        }
        else {
            if (!view.plugins) {
                throw new AppStructureBuilderError(`View ${viewName} has no plugins`);
            }
            delete view.plugins[name];
        }
    });
    return this;
}
//# sourceMappingURL=pluginManagement.js.map